import { Box, Text, Tooltip } from '@wix/design-system';
import React from 'react';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { ModalsModule } from '../../module/extensions/ModalsExtensions';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common/odeditor';
import { useIsMobile } from '@wix/core-domain-search';
import commonStyles from '../common.scss';
import { DomainWithEllipsis } from '../DomainWithEllipsis';
export const AITldDisclaimer = _ref => {
  let domainName = _ref.domainName;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobile ? /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: commonStyles.infoIcon,
    "data-hook": "ai-tld-disclaimer-info-icon",
    onClick: event => {
      event.stopPropagation();
      const infoModal = ModalsModule.internals.domainsSharedModalsController.infoModal;
      infoModal.show({
        title: /*#__PURE__*/React.createElement(DomainWithEllipsis, {
          maxWidth: "220px",
          textComponentProps: {
            weight: 'bold'
          }
        }, domainName),
        content: /*#__PURE__*/React.createElement(Text, {
          size: "small",
          weight: "thin"
        }, t('domain_search_suite.tld_section.ai_tooltip.text'))
      });
    }
  }) : /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement(Box, {
      padding: "SP3 SP4"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "thin",
      light: true
    }, t('domain_search_suite.tld_section.ai_tooltip.text')))
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: commonStyles.infoIcon
  }))));
};
//# sourceMappingURL=AITldDisclaimer.js.map